export const dedupeById = <T extends { id: number }>(arr: T[]) =>
	Array.from(new Map(arr.map((i) => [i.id, i])).values());
